<script>
	export let id = null;
	export let name = null;
	export let label = null;
	export let sublabel = null;
	export let value = null;
	export let maxlength = null;
	export let placeholder = null;
	export let rows = 3;
	export let required = null;
	export let disabled = null;
</script>

{#if label}
	<label for={id}>
		{label}

		{#if required}
			<span class="required">*</span>
		{/if}

		{#if sublabel}
			<div class="sublabel">{sublabel}</div>
		{/if}
	</label>
{/if}

{#if disabled}
	<div class="form-control disabled-textarea-display">{value || ""}</div>
{:else}
	<textarea {required} {disabled} {id} {name} {maxlength} {rows} {placeholder} bind:value class="form-control" />
{/if}

<style>
	textarea {
		height: auto;
	}

	.disabled-textarea-display {
		min-height: calc(1.5em + 0.75rem + 2px);
		height: auto;
		background-color: var(--bs-secondary-bg, #e9ecef);
		opacity: 1;
		white-space: pre-wrap;
		word-break: break-word;
		border: solid 1px var(--color-border);
		border-radius: 1px;
		font-size: 18px;
		line-height: 26px;
		color: var(--color-body);
	}
</style>
